import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { DEFAULT_PAGE } from '~/utils/constants/common';
import { IClient, ICRMListView, IDocument, IActivityLog } from '~/utils/interface/crm';
import { IJobEntity } from '~/apis/crm';
import { handleCreateCRMLead, handleGetClientDetails, handleGetCRMListView, handleGetCustomerJobs, handleGetDocuments, handleGetActivities } from './crmThunk';
import { handleGetAllEstimate } from '../job/jobThunk';

export interface crmState {
  crmListViews: Array<ICRMListView>;
  documents: Array<IDocument>;
  customerJobs: Array<IJobEntity>;
  activities: Array<IActivityLog>;
  client: IClient;
  currentPage: number;
  totalPage: number;
  totalItems: number;
  jobsCurrentPage: number;
  jobsTotalPage: number;
  jobsTotalItems: number;
  activitiesCurrentPage: number;
  activitiesTotalPage: number;
  activitiesTotalItems: number;
  needRefreshData: boolean;
  jobsLoading: boolean;
  activitiesLoading: boolean;


}

const initialState: crmState = {
  crmListViews: [],
  documents: [],
  customerJobs: [],
  activities: [],
  client: {} as IClient,
  currentPage: DEFAULT_PAGE,
  totalPage: 0,
  totalItems: 0,
  jobsCurrentPage: DEFAULT_PAGE,
  jobsTotalPage: 0,
  jobsTotalItems: 0,
  activitiesCurrentPage: DEFAULT_PAGE,
  activitiesTotalPage: 0,
  activitiesTotalItems: 0,
  needRefreshData: false,
  jobsLoading: false,
  activitiesLoading: false,
};

const crmSlice = createSlice({
  name: 'crm',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setCurrentPage(state, action: PayloadAction<number>) {
      state.currentPage = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetCRMListView.fulfilled, (state, action) => {
        state.crmListViews = [...action.payload.responses];
        state.currentPage = action.payload.pagination.page;
        state.totalPage = action.payload.pagination.totalPage;
        state.totalItems = action.payload.pagination.totalItems;
        state.needRefreshData = false;
      })
      .addCase(handleCreateCRMLead.fulfilled, (state) => {
        state.needRefreshData = true;
      })
      .addCase(handleGetDocuments.fulfilled, (state, action) => {
        state.documents = [...action.payload.responses];
        state.needRefreshData = false;
      })
      .addCase(handleGetClientDetails.fulfilled, (state, action) => {
        state.client = { ...action.payload.data };
        state.needRefreshData = false;
      })
      .addCase(handleGetCustomerJobs.pending, (state) => {
        state.jobsLoading = true;
      })
      .addCase(handleGetCustomerJobs.fulfilled, (state, action) => {
        state.customerJobs = [...action.payload.data];
        state.jobsCurrentPage = action.payload.page;
        state.jobsTotalPage = Math.ceil(action.payload.total / action.payload.limit);
        state.jobsTotalItems = action.payload.total;
        state.jobsLoading = false;
      })
      .addCase(handleGetCustomerJobs.rejected, (state) => {
        state.jobsLoading = false;
      })
      .addCase(handleGetActivities.pending, (state) => {
        state.activitiesLoading = true;
      })
      .addCase(handleGetActivities.fulfilled, (state, action) => {
        state.activities = [...action.payload.responses];
        state.activitiesCurrentPage = action.payload.pagination.page;
        state.activitiesTotalPage = action.payload.pagination.totalPage;
        state.activitiesTotalItems = action.payload.pagination.totalItems;
        state.activitiesLoading = false;
      })
      .addCase(handleGetActivities.rejected, (state) => {
        state.activitiesLoading = false;
      })
  },
});

export const crmActions = crmSlice.actions;

const crmReducer = crmSlice.reducer;
export default crmReducer;